declare namespace $ {

	type $bog_gamengine_phys__tile_bog_gamengine_demo_crumb2_level_1 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2_level['Tile'] >
		,
		ReturnType< $bog_gamengine_phys['tile'] >
	>
	type $bog_gamengine_phys__bodies_bog_gamengine_demo_crumb2_level_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_gamengine_phys['bodies'] >
	>
	type $bog_gamengine_tilemap__name_bog_gamengine_demo_crumb2_level_3 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_tilemap['name'] >
	>
	type $bog_gamengine_tilemap__tile_bog_gamengine_demo_crumb2_level_4 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2_level['Tile'] >
		,
		ReturnType< $bog_gamengine_tilemap['tile'] >
	>
	type $bog_gamengine_tilemap__atlas_bog_gamengine_demo_crumb2_level_5 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2_level['Atlas'] >
		,
		ReturnType< $bog_gamengine_tilemap['atlas'] >
	>
	type $bog_gamengine_tilemap__palette_bog_gamengine_demo_crumb2_level_6 = $mol_type_enforce<
		({ 
			'#': string,
			'.': string,
		}) 
		,
		ReturnType< $bog_gamengine_tilemap['palette'] >
	>
	type $bog_gamengine_phys_walker__name_bog_gamengine_demo_crumb2_level_7 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_phys_walker['name'] >
	>
	type $bog_gamengine_phys_walker__pos_bog_gamengine_demo_crumb2_level_8 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2_level['Hero_pos'] >
		,
		ReturnType< $bog_gamengine_phys_walker['pos'] >
	>
	type $bog_gamengine_phys_walker__size_bog_gamengine_demo_crumb2_level_9 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2_level['Hero_size'] >
		,
		ReturnType< $bog_gamengine_phys_walker['size'] >
	>
	type $bog_gamengine_phys_walker__speed_bog_gamengine_demo_crumb2_level_10 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_phys_walker['speed'] >
	>
	type $bog_gamengine_phys_walker__role_bog_gamengine_demo_crumb2_level_11 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_phys_walker['role'] >
	>
	type $bog_gamengine_sprite__name_bog_gamengine_demo_crumb2_level_12 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['name'] >
	>
	type $bog_gamengine_sprite__atlas_bog_gamengine_demo_crumb2_level_13 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2_level['Atlas'] >
		,
		ReturnType< $bog_gamengine_sprite['atlas'] >
	>
	type $bog_gamengine_sprite__frame_bog_gamengine_demo_crumb2_level_14 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['frame'] >
	>
	type $bog_gamengine_sprite__pos_bog_gamengine_demo_crumb2_level_15 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2_level['Coin_pos'] >
		,
		ReturnType< $bog_gamengine_sprite['pos'] >
	>
	type $bog_gamengine_sprite__role_bog_gamengine_demo_crumb2_level_16 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['role'] >
	>
	type $bog_gamengine_sprite__name_bog_gamengine_demo_crumb2_level_17 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['name'] >
	>
	type $bog_gamengine_sprite__atlas_bog_gamengine_demo_crumb2_level_18 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2_level['Atlas'] >
		,
		ReturnType< $bog_gamengine_sprite['atlas'] >
	>
	type $bog_gamengine_sprite__frame_bog_gamengine_demo_crumb2_level_19 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['frame'] >
	>
	type $bog_gamengine_sprite__pos_bog_gamengine_demo_crumb2_level_20 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2_level['Sprite_1_pos'] >
		,
		ReturnType< $bog_gamengine_sprite['pos'] >
	>
	type $bog_gamengine_sprite__role_bog_gamengine_demo_crumb2_level_21 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['role'] >
	>
	type $bog_gamengine_sprite__name_bog_gamengine_demo_crumb2_level_22 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['name'] >
	>
	type $bog_gamengine_sprite__atlas_bog_gamengine_demo_crumb2_level_23 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2_level['Atlas'] >
		,
		ReturnType< $bog_gamengine_sprite['atlas'] >
	>
	type $bog_gamengine_sprite__frame_bog_gamengine_demo_crumb2_level_24 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['frame'] >
	>
	type $bog_gamengine_sprite__pos_bog_gamengine_demo_crumb2_level_25 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2_level['Sprite_2_pos'] >
		,
		ReturnType< $bog_gamengine_sprite['pos'] >
	>
	type $bog_gamengine_sprite__role_bog_gamengine_demo_crumb2_level_26 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['role'] >
	>
	type $bog_gamengine_sprite__name_bog_gamengine_demo_crumb2_level_27 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['name'] >
	>
	type $bog_gamengine_sprite__atlas_bog_gamengine_demo_crumb2_level_28 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2_level['Atlas'] >
		,
		ReturnType< $bog_gamengine_sprite['atlas'] >
	>
	type $bog_gamengine_sprite__frame_bog_gamengine_demo_crumb2_level_29 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['frame'] >
	>
	type $bog_gamengine_sprite__pos_bog_gamengine_demo_crumb2_level_30 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2_level['Sprite_3_pos'] >
		,
		ReturnType< $bog_gamengine_sprite['pos'] >
	>
	type $bog_gamengine_sprite__role_bog_gamengine_demo_crumb2_level_31 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['role'] >
	>
	type $bog_gamengine_sprite__name_bog_gamengine_demo_crumb2_level_32 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['name'] >
	>
	type $bog_gamengine_sprite__atlas_bog_gamengine_demo_crumb2_level_33 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2_level['Atlas'] >
		,
		ReturnType< $bog_gamengine_sprite['atlas'] >
	>
	type $bog_gamengine_sprite__frame_bog_gamengine_demo_crumb2_level_34 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['frame'] >
	>
	type $bog_gamengine_sprite__pos_bog_gamengine_demo_crumb2_level_35 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_crumb2_level['Sprite_4_pos'] >
		,
		ReturnType< $bog_gamengine_sprite['pos'] >
	>
	type $bog_gamengine_sprite__role_bog_gamengine_demo_crumb2_level_36 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['role'] >
	>
	type $bog_gamengine_phys_tile__map_bog_gamengine_demo_crumb2_level_37 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_phys_tile['map'] >
	>
	type $bog_gamengine_atlas__uris_bog_gamengine_demo_crumb2_level_38 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_gamengine_atlas['uris'] >
	>
	type $bog_gamengine_atlas__size_bog_gamengine_demo_crumb2_level_39 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_atlas['size'] >
	>
	export class $bog_gamengine_demo_crumb2_level extends $bog_gamengine_scene {
		Phys( ): $bog_gamengine_phys
		Tiles( ): $bog_gamengine_tilemap
		Hero_pos( next?: Float32Array ): Float32Array
		Hero_size( next?: Float32Array ): Float32Array
		Hero( ): $bog_gamengine_phys_walker
		Coin_pos( next?: Float32Array ): Float32Array
		Coin( ): $bog_gamengine_sprite
		Sprite_1_pos( next?: Float32Array ): Float32Array
		Sprite_1( ): $bog_gamengine_sprite
		Sprite_2_pos( next?: Float32Array ): Float32Array
		Sprite_2( ): $bog_gamengine_sprite
		Sprite_3_pos( next?: Float32Array ): Float32Array
		Sprite_3( ): $bog_gamengine_sprite
		Sprite_4_pos( next?: Float32Array ): Float32Array
		Sprite_4( ): $bog_gamengine_sprite
		phys( ): ReturnType< $bog_gamengine_demo_crumb2_level['Phys'] >
		Tile( ): $bog_gamengine_phys_tile
		kids( ): readonly(any)[]
		Atlas( ): $bog_gamengine_atlas
	}
	
}

//# sourceMappingURL=level.view.tree.d.ts.map